import React, { useState, useRef, useEffect, useCallback } from 'react';
import { Camera } from 'react-camera-pro';
import Webcam from 'react-webcam';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useForm } from 'react-hook-form';
import { detectMob, getCertifacationNumber } from '../../../utils/common';
import LightBulb from '../../../assets/images/light-bulb.svg';
import Loading from '../../../components/Common/Loading';
import InvalidToken from '../../../components/PopUpBox/InvalidToken';

import { actionApplyLater, actionImageQuanlity, actionTsoOcrDa } from '../../../store/application/actions';
import { actionApplicationIP } from '../../../store/common/actions';

import * as ort from 'onnxruntime-web';
import certis from '../../../utils/certis';
import Coordinate from '../../../utils/coordinate';
import preprocess from '../../../utils/tensor';
import { runModel } from '../../../utils/runModel';
import warpWebGl from '../../../utils/webgl-distort';
import getMessage from '../../../utils/message';
import EventEmitter from 'wolfy87-eventemitter';
import Error from '../Error';
const pica = require('pica')();

const COUNT_TIMES = 4;

const target = { width: 256, height: 256, fullWidth: 1080, left: 0, top: 0 };
const coordinate = new Coordinate({ imgSize: target.width });
const event = new EventEmitter();
let delayTimer;

let cur_step = 1;
let cur_images = [];
let cur_docids = [];

function IDCardTakePhoto({ cardType, defaultCount }) {
  const camera = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [images, setImages] = useState(location.state?.current?.images ?? []);
  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState(null);
  const canvasRef = useRef();
  const maxCanvasRef = useRef();
  const modelRef = useRef(null);
  const toast = useRef(null);
  const {
    handleSubmit,
    formState: { isSubmitting },
  } = useForm();
  const [countTimes, setCountTimes] = useState(defaultCount ?? COUNT_TIMES);
  const [isVisibleInvalidToken, setIsVisibleInvalidToken] = useState(false);
  const [step, setStep] = useState(location.state?.current?.step ?? 1);
  const [showNextStep, setShowNextStep] = useState(false);
  const [countDown, setCountDown] = useState(5);
  const [docIds, setDocIds] = useState(location.state?.current?.docIds ?? []);


  useEffect(() => {
    if (location.state?.count || location.state?.count === 0) {
      setCountTimes(location.state?.count);
    }
  }, [location.state?.count]);


  function sleep(s) {
    return new Promise((resolve) => {
      setTimeout(resolve, s)
    })
  }

  async function init() {
    await loadModel()
    await sleep(2000)
    await pub()
    await shotScreen()
  }

  useEffect(() => {
    console.log(location.state?.current);
    cur_step = location.state?.current?.step ?? 1;
    cur_images = location.state?.current?.images ?? [];
    cur_docids = location.state?.current?.docIds ?? [];
    certis.reset(location.state?.current?.certis_step ?? 1);
    init()
  }, [location.state?.current]);

  const onSubmit = async () => {
    const response = await dispatch(
      actionTsoOcrDa({
        photo: images[0],
        incline_front: images[1],
        vertical_back: images[2],
        version: cardType,
        application_io: getPlatformInfo(),
        flow: 1,
        vertical_front_id: docIds[0],
        incline_front_id: docIds[1],
        vertical_back_id: docIds[2],
      }),
    );

    if (response?.sts_code === 3) {
      // INVALID_TOKEN
      setIsVisibleInvalidToken(true);
      return;
    }
    if (response?.sts_code === 26) {
      // doc auth ocr error 
      apply(images[0]);
      return;
    }
    navigate('/application-id-check-result', { replace: true, state: { status: true, result: response?.sts_code, count: countTimes } });
  };

  const getUtmParams = async () => {
    const responseIP = await dispatch(actionApplicationIP());
    let data = {};
    const utm_medium = sessionStorage.getItem('utm_medium');
    const utm_source = sessionStorage.getItem('utm_source');
    const utm_campaign = sessionStorage.getItem('utm_campaign');
    const utm_id = sessionStorage.getItem('utm_id');
    const utm_term = sessionStorage.getItem('utm_term');
    const utm_content = sessionStorage.getItem('utm_content');
    const session_id = localStorage.getItem('session_id');
    data = {
      session_id,
      utm_medium,
      utm_source,
      utm_campaign,
      utm_id,
      utm_term,
      utm_content,
      ip: responseIP?.ip ?? '',
      access_query: `utm_medium=${utm_medium ?? ''}&utm_source=${utm_source ?? ''}&utm_campaign=${utm_campaign ?? ''}&utm_id=${utm_id ?? ''}&utm_term=${utm_term ?? ''}&utm_content=${utm_content ?? ''}`,
    }
    return data;
  }

  // try apply request later
  async function apply(photo) {
    const utm_params = await getUtmParams();
    dispatch(actionApplyLater({
      utm_params,
      step: 'HKID',
      photo
    }));
    navigate('/application/confirm/complete', { replace: true, state: { status: true, completed: false, content: '' } });
  }

  const onImageQuanlity = async (image, next_step = true) => {
    const response = await dispatch(
      actionImageQuanlity({
        photo: image
      }),
    );
    if (response?.sts_code === 3) {
      // INVALID_TOKEN
      setIsVisibleInvalidToken(true);
      return;
    }
    const success = response?.sts_code === 0; // TODO: for test
    if (success) {
      next_step && onNextStep()
      setDocIds(prev => {
        return [...prev, response?.content]
      });
      cur_images.push(image);
      cur_docids.push(response?.content);
      cur_step += 1;
    } else {
      console.log('cur_images - cur_step', cur_images, cur_step)
      navigate('/application-id-check-result', {
        replace: true,
        state: {
          status: true,
          result: success,
          count: countTimes,
          photo: image,
          current: {
            step: cur_step,
            certis_step: cur_step === 1 ? 1 : (cur_step === 2 ? 3 : 5),
            images: cur_images,
            docIds: cur_docids
          }
        }
      });
    }
  }

  const getPlatformInfo = () => {
    let platformInfo = {
      device_type: '',
      browser_type: '',
      browser_version: '',
      os: ''
    };
    if (window.platform) {
      platformInfo.device_type = detectMob() ? 'Mobile' : 'PC';
      platformInfo.browser_type = window.platform.name;
      platformInfo.browser_version = window.platform.version;
      platformInfo.os = window.platform.os.family;
    }
    return JSON.stringify(platformInfo);
  }

  const getStepText = () => {
    switch (step) {
      case 1:
        return '1: 請拍攝身份証的正面';
      case 2:
        return '2: 請稍微傾斜身份証';
      case 3:
        return '3: 請拍攝身份証的背面';
      default:
        return '1: 請拍攝身份証的正面';
    }
  }

  const onTakePhoto = async () => {
    console.log(camera.current);
    const currentImage = detectMob() ? camera.current.takePhoto() : camera.current.getScreenshot()
    setImage(currentImage)
    setImages(prev => {
      return [...prev, {
        step: step,
        image: currentImage
      }]
    });
    await shotScreen()
  }

  // DA lite SDK

  async function loadModel() {
    try {
      modelRef.current = await ort.InferenceSession.create('/static/js/dalite_sim_next.onnx');
      console.log('---------- Load model success ---------- ', modelRef.current)
    } catch (e) {
      console.log(e)
      alert('图像分析模型加载失败，请刷新');
    }
  }

  function saveAsPNG(canvas) {
    return canvas.toDataURL("image/png", 1.0);
  }

  function saveAsJPG(canvas) {
    return canvas.toDataURL("image/jpeg", 1.0);
  }

  const shotScreen = useCallback(
    async () => {
      //  video相关参数
      const isMobile = detectMob();
      const video = isMobile ? document.getElementById("video") : camera.current.video;
      const videoRatioX = video.videoWidth / video.clientWidth;
      const videoRatioY = video.videoHeight / video.clientHeight;

      const maxCanvas = maxCanvasRef.current;
      const maxCanvasContext = maxCanvas.getContext("2d");
      const previewHeight = 2.9 * window.baseFontSize;
      const middleHeight = 7.5 * window.baseFontSize;
      const more = video.clientHeight - previewHeight - middleHeight;
      const min = Math.min(previewHeight, more);
      const maxVideo = {
        width: video.clientWidth,
        height: middleHeight + min * 2
      }
      //  计算传递给后端的照片的canvas宽高，其中宽是1080，高需要实时计算
      const maxCanvasRatio = target.fullWidth / document.documentElement.clientWidth;
      maxCanvas.width = target.fullWidth;
      maxCanvas.height = maxVideo.height * maxCanvasRatio;
      maxCanvasContext.drawImage(
        video,
        0,
        (previewHeight - min) * videoRatioY,
        maxVideo.width * videoRatioX,
        maxVideo.height * videoRatioY,
        0,
        0,
        maxCanvas.width,
        maxCanvas.height
      );

      const context = canvasRef.current.getContext("2d");
      //  根据ratio计算可视区域w h

      canvasRef.current.width = target.fullWidth;
      canvasRef.current.height = 720;
      context.drawImage(video, 0, 0, canvasRef.current.width, canvasRef.current.height);

      const inputImage = saveAsPNG(canvasRef.current);
      const inputImageJpg = saveAsJPG(canvasRef.current);

      // setPreview(inputImage)

      //  压缩
      const resizeCanvas = document.createElement('canvas');
      resizeCanvas.width = target.width;
      resizeCanvas.height = target.height;
      await pica.resize(canvasRef.current, resizeCanvas, {
        unsharpAmount: 160,
        unsharpRadius: 0.6,
        unsharpThreshold: 1
      })

      // Raw image
      const rawCanvas = document.createElement('canvas');
      rawCanvas.width = video.clientWidth;
      rawCanvas.height = video.clientHeight;
      const rawContext = rawCanvas.getContext("2d")
      rawContext.drawImage(video, 0, 0, rawCanvas.width, rawCanvas.height);

      //  调用模型
      const preprocessedData = preprocess(resizeCanvas.getContext("2d"));
      const [tensorOutput, condition] = await runModel(
        modelRef.current,
        preprocessedData
      );

      //  模型code简单判断
      let code = getCertifacationNumber(condition.data);
      // console.log('code %s, certis.id %s, cardType %s', code, certis.id, cardType)
      coordinate.setPoints(tensorOutput.data);
      if (cardType === 2003 && code === 2) {
        return event.emitEvent('toastMessage', [{ code: 'NEEDOLD' }])
      } else if (cardType === 2018 && code === 1) {
        return event.emitEvent('toastMessage', [{ code: 'NEEDNEW' }])
      } else if (!cardType) {
        return event.emitEvent('toastMessage', [{ code: 'ERRORLINK' }])
      } else if (certis.id === 1 && code === 3) {
        return event.emitEvent('toastMessage', [{ code: 'NEEDFACE' }])
      } else if (certis.id === 3 && code === 3) {
        return event.emitEvent('toastMessage', [{ code: 'NEEDROTATE' }])
      } else if (certis.id === 5 && (code === 1 || code === 2)) {
        return event.emitEvent('toastMessage', [{ code: 'NEEDBACK' }])
      } else if (certis.id === 3 && code === 0) {
        return event.emitEvent('toastMessage', [{ code: 'LOOSE' }]);
      } else if (code === 0) {
        return event.emitEvent('toastMessage', [{ code: 'ERRORCERTI' }])
      }

      //  模型结果计算坐标
      const coordinateType = coordinate.checkRight(
        certis.id,
        coordinate.points,
        coordinate.distance,
        {
          imageWidth: video.clientWidth,
          offsetX: target.left,
          offsetY: target.top,
        }
      );
      if (coordinateType === 'EXCEED_LEFT') {
        return event.emitEvent('toastMessage', [{ code: 'EXCEED_LEFT' }])
      } else if (coordinateType === 'EXCEED_TOP') {
        return event.emitEvent('toastMessage', [{ code: 'EXCEED_TOP' }])
      } else if (coordinateType === 'EXCEED_RIGHT') {
        return event.emitEvent('toastMessage', [{ code: 'EXCEED_RIGHT' }])
      } else if (coordinateType === 'EXCEED_BOTTOM') {
        return event.emitEvent('toastMessage', [{ code: 'EXCEED_BOTTOM' }])
      } else if (coordinateType === 'LESS_ROTATE') {
        return event.emitEvent('toastMessage', [{ code: 'LESS_ROTATE' }])
      } else if (coordinateType === 'MORE_ROTATE') {
        return event.emitEvent('toastMessage', [{ code: 'MORE_ROTATE' }])
      } else if ((certis.id === 1 || certis.id === 2) && coordinateType === 'FAR') {
        return event.emitEvent('toastMessage', [{ code: 'FAR' }])
      } else if (coordinateType === 'MOREA') {
        return event.emitEvent('toastMessage', [{ code: 'MOREA' }])
      }
      //  压缩
      const previewCanvas = document.createElement('canvas');
      previewCanvas.width = coordinate.distance[3];
      previewCanvas.height = coordinate.distance[0];
      const previewContext = previewCanvas.getContext("2d");

      previewContext.drawImage(
        resizeCanvas,
        coordinate.points[0],
        coordinate.points[1],
        coordinate.distance[3],
        coordinate.distance[0],
        0,
        0,
        coordinate.distance[3],
        coordinate.distance[0]
      );

      const preview = saveAsPNG(previewCanvas);
      const maxImage = saveAsPNG(maxCanvas);
      const rawImage = saveAsPNG(rawCanvas);

      //  满足一下条件可以进行光照计算了
      if (
        (certis.id === 1 && code === 1) ||
        (certis.id === 1 && code === 2) ||
        (certis.id === 3 && code === 1) ||
        (certis.id === 3 && code === 2) ||
        (certis.id === 5 && code === 3)
      ) {
        //  @ts-ignore
        document.getElementById('img').src = inputImage;
        //  模型结果计算坐标
        const fxFlag = await warpWebGl(
          'img',
          //  @ts-ignore
          tensorOutput.data.map((item) => item * (1080 / 256)),
          [0, 0, 0, 629, 999, 629, 999, 0]
        );

        if (fxFlag === 'LIGHT') {
          return event.emitEvent('toastMessage', [{ code: 'LIGHT' }])
        } else if (fxFlag === 'DARK') {
          return event.emitEvent('toastMessage', [{ code: 'DARK' }])
        } else {
          //  识别成功
          // console.log('ok');
          event.emitEvent('toastMessage', [{ code: 'OK' }]);
          // setComplete(true);
          setImages((pre) => [...pre, inputImageJpg]);
          setPreview(inputImageJpg);

          const isLoose = await isLooseTask(10);
          if (certis.id === 1 && !isLoose) {
            return event.emitEvent('toastMessage', [{ code: 'LOOSE' }]);
          }

          setStep((prev) => prev + 1);
          certis.next();
          if (certis.id <= certis.max) {
            // setComplete(false);
            //await sleep(1000);
            //await shotScreen();
            await onImageQuanlity(inputImageJpg)
          } else {
            const video = document.getElementsByTagName('video')
            if (video.length > 0 && video[0]) {
              video[0].pause();
            }
            await onImageQuanlity(inputImageJpg, false)
          }
        }
      }
    },
    [modelRef.current],
  )

  const onNextStep = () => {
    let countDown = 5;
    const loop = setInterval(async () => {
      if (countDown > 0) {
        countDown -= 1;
        if (!showNextStep) setShowNextStep(true);
        setCountDown(countDown);
      } else {
        clearInterval(loop);
        setCountDown(5);
        setShowNextStep(false);
        await sleep(1000);
        await shotScreen();
      }
    }, 1000);
  }

  const isLooseTask = async (timer) => {
    //  video相关参数
    const isMobile = detectMob();
    const video = isMobile ? document.getElementById("video") : camera.current.video;
    const context = canvasRef.current.getContext("2d");
    //  根据ratio计算可视区域w h
    canvasRef.current.width = video.clientWidth;
    canvasRef.current.height = video.clientHeight;
    context.drawImage(video, 0, 0, canvasRef.current.width, canvasRef.current.height);

    //  压缩
    const resizeCanvas = document.createElement('canvas');
    resizeCanvas.width = target.width;
    resizeCanvas.height = target.height;
    await pica.resize(canvasRef.current, resizeCanvas, {
      unsharpAmount: 160,
      unsharpRadius: 0.6,
      unsharpThreshold: 1
    })

    //  调用模型
    const preprocessedData = preprocess(resizeCanvas.getContext("2d"));
    const [tensorOutput, condition] = await runModel(
      modelRef.current,
      preprocessedData
    );

    //  模型code简单判断
    let code = getCertifacationNumber(condition.data);
    coordinate.setPoints(tensorOutput.data);
    if (code === 0) {
      return false;
    } else if (timer === 0) {
      return true;
    }
    await sleep(100);
    return await isLooseTask(timer - 1);
  }

  const pub = useCallback(
    () => {
      async function listener(message) {
        if (delayTimer) {
          clearTimeout(delayTimer);
        }
        const { code } = message;
        const text = getMessage(code);
        // console.log('mgs', text, code)
        if (!toast.current) return;
        toast.current.style.display = 'block';
        toast.current.textContent = text;
        delayTimer = setTimeout(() => {
          toast.current.style.display = 'none';
        }, 1000);
        if (code === 'OK') {
          return toast.current.style.background = '#0FEDA2';
        } else {
          toast.current.style.background = '';
        }

        await sleep(1000);
        await shotScreen();
        // if (code !== 'LOOSE') {
        //   await sleep(1000);
        //   await shotScreen();
        // } else {
        //   certis.reset();
        //   // setImage([]);
        //   // setPreview([]);
        //   // setComplete(false);
        //   // setVisible(true);
        // }
      }
      event.addListeners('toastMessage', [listener])
    },
    [shotScreen, certis.id],
  )

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      {isVisibleInvalidToken && <InvalidToken />}
      <Loading isVisible={isSubmitting} />
      {showNextStep && <Error>
        <div className="text-center">
          <p className="text-gray1 my-6"> Next step {getStepText()} <span className="text-primary2">({countDown}s)</span></p>
        </div>
      </Error>}
      <div className="fixed w-full z-50 top-0 left-1/2 h-full bg-white" style={{ maxWidth: 414, transform: 'translateX(-50%)' }}>
        <p className="p-4 text-gray text-center">{!image ? '請拍攝閣下的香港永久性居民身份證' : '請確認閣下所拍攝的照片'}</p>
        <div className="relative">
          {!image ? (
            <>
              {detectMob() ? (
                <Camera
                  ref={camera}
                  facingMode="environment"
                  aspectRatio={4 / 3}
                  errorMessages={{
                    noCameraAccessible: '請允許相機權限以繼續貸款申請。',
                    permissionDenied: '没有权限。请刷新并授予相机权限。',
                    switchCamera: '无法将摄像头切换到其他摄像头，因为只能访问一个视频设备。',
                    canvas: '不支持画布。',
                  }}
                />
              ) : (
                <Webcam
                  ref={camera}
                  audio={false}
                  height={1080}
                  screenshotFormat="image/jpeg"
                  width={1080}
                  minScreenshotHeight={245}
                  videoConstraints={{
                    facingMode: 'environment',
                  }}
                />
              )}
            </>
          ) : (
            <img src={image} alt="" />
          )}
          <div className="absolute top-5 left-5 w-10 h-10 border-t-4 border-l-4 border-white" />
          <div className="absolute top-5 right-5 w-10 h-10 border-t-4 border-r-4 border-white" />
          <div className="absolute bottom-5 left-5 w-10 h-10 border-b-4 border-l-4 border-white" />
          <div className="absolute bottom-5 right-5 w-10 h-10 border-b-4 border-r-4 border-white" />
          <div ref={toast} className="absolute top-1/3 left-1/3 px-5 py-2 text-white bg-red-500 hidden rounded-md"></div>
          <canvas style={{ display: 'none' }} ref={canvasRef}></canvas>
          <canvas style={{ display: 'none' }} ref={maxCanvasRef}></canvas>
          <img id="img" src="vertical_front.png" style={{ display: 'none' }} />
        </div>
        {!image && step < 4 ? (
          <>
            <p className="text-xl text-primary text-center mt-3 font-semibold">Step: {getStepText()}</p>
            {/* <img id="preview" src={preview} style={{display: preview ? 'block' : 'none'}} /> */}
            <div className="p-4 pb-0 flex items-center text-lg mb-2">
              <img src={LightBulb} alt="" className="cursor-pointer" />
              <p className="text-gray1 underline mt-2">拍攝身份證小貼士</p>
            </div>
            <p className="p-4 pt-0 text-gray1 ml-4">
              ・移除身份證透明卡套
              <br />
              ・確保四周光線充足
              <br />
              ・避免身份證資料模糊/反光/有陰影
              <br />
              ・應在與有強烈對比的平面背景上拍攝
              <br />
              ・避免遮擋身份證正面任何位置
            </p>
          </>
        ) : (
          <>
            <div className="flex justify-center mt-9 mb-4">
              <button style={{ width: 160 }} disabled={isSubmitting || docIds.length < 3} type="submit" className={`rounded-full text-white text-xl px-14 py-3 ${(isSubmitting || docIds.length < 3) ? 'bg-mercury' : 'bg-primary'}`}>
                確定
              </button>
            </div>
          </>
        )}
      </div>
    </form>
  );
}

export default IDCardTakePhoto;
